var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Formio } from 'formiojs';
import editFormAddons from './editForm/HouseNumberAdditionPostcodeAPI.edit.addons';
var Components = Formio.Components;
var TextFieldComponent = Formio.Components.components.textfield;
/**
 * HouseNumberAdditionPostcodeAPI class extending from a formio text field component
 *
 * @author Raphaël OLIVERO <@RaphaelOlivero>
 * @copyright Novti - 2022
 */
var HouseNumberAdditionPostcodeAPI = /** @class */ (function (_super) {
    __extends(HouseNumberAdditionPostcodeAPI, _super);
    /**
     * Called when the component has been instantiated. This is useful to define
     * default instance variable values.
     *
     * @param component - The JSON representation of the component created.
     * @param options - The global options for the renderer
     * @param data - The contextual data object (model) used for this component.
     */
    function HouseNumberAdditionPostcodeAPI(component, options, data) {
        return _super.call(this, component, options, data) || this;
    }
    /**
     * Called immediately after the component has been instantiated to initialize
     * the component.
     */
    HouseNumberAdditionPostcodeAPI.prototype.init = function () {
        _super.prototype.init.call(this);
    };
    /**
     * This is the default schema of your custom component. It will "derive"
     * from the base class "schema" and extend it with its default JSON schema
     * properties. The most important are "type" which will be your component
     * type when defining new components.
     *
     * @param extend - This allows classes deriving from this component to
     *                 override the schema of the overridden class.
     */
    HouseNumberAdditionPostcodeAPI.schema = function () {
        var extend = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extend[_i] = arguments[_i];
        }
        return TextFieldComponent.schema.apply(TextFieldComponent, __spreadArrays([{
                label: 'House Number Addition (Postcode API)',
                key: 'houseNumberAdditionPostcodeAPI',
            }], extend));
    };
    Object.defineProperty(HouseNumberAdditionPostcodeAPI, "builderInfo", {
        /**
         * This is the Form Builder information on how this component should show
         * up within the form builder. The "title" is the label that will be given
         * to the button to drag-and-drop on the buidler. The "icon" is the font awesome
         * icon that will show next to it, the "group" is the component group where
         * this component will show up, and the weight is the position within that
         * group where it will be shown. The "schema" field is used as the default
         * JSON schema of the component when it is dragged onto the form.
         */
        get: function () {
            return {
                title: 'House Number Addition (Postcode API)',
                icon: 'terminal',
                group: 'basic',
                documentation: '/userguide/#input',
                weight: 0,
                schema: HouseNumberAdditionPostcodeAPI.schema()
            };
        },
        enumerable: false,
        configurable: true
    });
    HouseNumberAdditionPostcodeAPI.prototype.render = function () {
        // if (this.data?.postcodeApiAddress?.houseNumberAdditions && this.data?.postcodeApiAddress?.houseNumberAdditions?.length > 0) {
        //   const optionList = this.data.postcodeApiAddress.houseNumberAdditions
        //   let datalistElement = document.getElementById('house-number-additions-datalist')
        //   if (datalistElement === undefined || datalistElement === null) {
        //     datalistElement = document.createElement('datalist')
        //     datalistElement.id = 'house-number-additions-datalist'
        //   }
        //   // Remove existing elements
        //   datalistElement.innerHTML = ''
        //   for (let i = 0; i < optionList.length; i++) {
        //     const option = document.createElement('option')
        //     if (optionList[i] === '') {
        //       continue
        //     }
        //     option.value = optionList[i]
        //     datalistElement.appendChild(option)
        //   }
        //   document.body.appendChild(datalistElement)
        // }
        return _super.prototype.render.call(this);
    };
    /**
     * Sets the value of both the data and view of the component (such as setting the
     * <input> value to the correct value of the data. This is most commonly used
     * externally to set the value and also see that value show up in the view of the
     * component. If you wish to only set the data of the component, like when you are
     * responding to an HMTL input event, then updateValue should be used instead since
     * it only sets the data value of the component and not the view.
     *
     * @param value - The value that is being set for this component's data and view.
     * @param flags - Change propogation flags that are being used to control behavior of the
     *                change proogation logic.
     *
     * @return - Boolean indicating if the setValue changed the value or not.
     */
    HouseNumberAdditionPostcodeAPI.prototype.setValue = function (value, flags) {
        if (flags === void 0) { flags = {}; }
        return _super.prototype.setValue.call(this, value, flags);
    };
    /**
     * Returns the value of the "view" data for this component.
     *
     * @return - The value for this whole component.
     */
    HouseNumberAdditionPostcodeAPI.prototype.getValue = function () {
        return _super.prototype.getValue.call(this);
    };
    return HouseNumberAdditionPostcodeAPI;
}(TextFieldComponent));
export default HouseNumberAdditionPostcodeAPI;
HouseNumberAdditionPostcodeAPI.editForm = function () {
    return TextFieldComponent.editForm(__spreadArrays(editFormAddons));
};
Components.addComponent('housenumberadditionpostcodeapi', HouseNumberAdditionPostcodeAPI);
